<template lang="html">
  <div class="wangeditor">
    <div ref="toolbar" class="toolbar"></div>
    <div ref="wangeditor" class="text"></div>
  </div>
</template>

<script>
import E from "wangeditor";
import global from "@/utils/global";
import md5 from "js-md5";
export default {
  data() {
    return {
      wangEditor: null,
      wangEditorInfo: null,
      now:Date.parse(new Date()) / 1000,
    };
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    isClear: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isClear(val) {
      // 触发清除文本域内容
      if (val) {
        this.wangEditor.txt.clear();
        this.wangEditorInfo = null;
      }
    },
    value: function(value) {
      if (value !== this.wangEditor.txt.html()) {
        this.isClear = false;
        this.wangEditor.txt.html(this.value); //value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值
      }
    }
  },
  mounted() {
    this.initEditor();
    this.wangEditor.txt.html(this.value);
  },
  methods: {
    initEditor() {
      this.wangEditor = new E(this.$refs.toolbar, this.$refs.wangeditor);
      this.wangEditor.customConfig = this.wangEditor.customConfig ? this.wangEditor.customConfig : this.wangEditor.config
      // this.wangEditor.customConfig.uploadImgShowBase64 = true; // base64存储图片（推荐）
      this.wangEditor.customConfig.uploadImgServer = global.syOssUrl + '/upload2Oss' // 配置服务器端地址（不推荐）
      this.wangEditor.customConfig.uploadImgHeaders = {
        'timestamp': this.now,
        'sign': md5('6486b66b41f8df68777eac23'+this.now)
      }; // 自定义header
      this.wangEditor.config.uploadImgParams = {        //自定义上传参数
        type: 'image'
      }
      this.wangEditor.customConfig.uploadFileName = "file"; // 后端接受上传文件的参数名
      this.wangEditor.customConfig.uploadImgMaxSize = 2 * 1024 * 1024; // 将图片大小限制为（默认最大支持2M）
      this.wangEditor.customConfig.uploadImgMaxLength = 6; // 限制一次最多上传6张图片
      this.wangEditor.customConfig.uploadImgTimeout = 1 * 60 * 1000; // 设置超时时间（默认1分钟）

      //视频
      this.wangEditor.config.uploadVideoServer = global.syOssUrl + '/upload2Oss'
      this.wangEditor.config.uploadVideoParams = {
        type:'video'
      }
      this.wangEditor.config.uploadVideoName = 'file'
      this.wangEditor.config.uploadVideoHeaders = {
        'timestamp': this.now,
        'sign': md5('6486b66b41f8df68777eac23'+this.now)
      }
      this.wangEditor.config.uploadVideoMaxSize = 1 * 1024 * 1024 * 1024 // 1024m
      //限制类型
      // editor.config.uploadVideoAccept = ['mp4']

      // 配置菜单
      this.wangEditor.customConfig.menus = [
        "head", // 标题
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        "emoticon", // 表情
        "image", // 插入图片
        "table", // 表格
        "video", // 插入视频
        "code", // 插入代码
        "undo", // 撤销
        "redo", // 重复
        "fullscreen" // 全屏
      ];

      this.wangEditor.customConfig.uploadImgHooks = {
        // 上传图片之前
        before: (xhr) =>  {
          //起到刷新header的作用，此方法执行时，图片也在进行上传操作
          this.now = Date.parse(new Date()) / 1000;
          this.wangEditor.customConfig.uploadImgHeaders = {
            'timestamp': this.now,
            'sign': md5('6486b66b41f8df68777eac23'+this.now)
          }
        },
        fail: (xhr, editor, result) => {
          // 插入图片失败回调
        },
        success: (xhr, editor, result) => {
          // 图片上传成功回调
        },
        timeout: (xhr, editor) => {
          // 网络超时的回调
        },
        error: (xhr, editor) => {
          // 图片上传错误的回调
        },
        // 图片上传并返回了结果，想要自己把图片插入到编辑器中
        // 例如服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
        customInsert: (insertImg, result) => {
          // 图片上传成功，插入图片的回调（不推荐）
          insertImg(result.msg);
        }
      };

      this.wangEditor.config.uploadVideoHooks = {
        // 上传视频之前
        before: (xhr) =>  {
          //起到刷新header的作用
          this.now = Date.parse(new Date()) / 1000;
          this.wangEditor.customConfig.uploadImgHeaders = {
            'timestamp': this.now,
            'sign': md5('6486b66b41f8df68777eac23'+this.now)
          }
        },
        // 视频上传并返回了结果，视频插入已成功
        success: function(xhr) {
          console.log('success', xhr)
        },
        // 视频上传并返回了结果，但视频插入时出错了
        fail: function(xhr, editor, resData) {
          console.log('fail', resData)
        },
        // 上传视频出错，一般为 http 请求的错误
        error: function(xhr, editor, resData) {
          console.log('error', xhr, resData)
        },
        // 上传视频超时
        timeout: function(xhr) {
          console.log('timeout')
        },
        // 视频上传并返回了结果，想要自己把视频插入到编辑器中
        // 例如服务器端返回的不是 { errno: 0, data: { url : '.....'} } 这种格式，可使用 customInsert
        customInsert: function(insertVideoFn, result) {
          // result 即服务端返回的接口
          console.log('customInsert', result)

          // insertVideoFn 可把视频插入到编辑器，传入视频 src ，执行函数即可
          insertVideoFn(result.msg)
        }
      }
      this.wangEditor.customConfig.onchange = html => {
        this.wangEditorInfo = html;
        this.$emit("change", this.wangEditorInfo); // 将内容同步到父组件中
      };
      // 创建富文本编辑器
      this.wangEditor.create();
    }
  }
};
</script>

<style lang="scss">
.wangeditor {
  border: 1px solid #e6e6e6;
  box-sizing: border-box;
  .toolbar {
    border-bottom: 1px solid #e6e6e6;
    box-sizing: border-box;
  }
  .text {
    min-height: 300px;
  }
}
</style>
